import React, { useEffect, useState } from 'react';
import './PreLander.scss';

function PreLander({ contentLoaded }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setProgress((prevProgress) => {
        const newProgress = prevProgress + 1;
        return newProgress > 100 ? 100 : newProgress;
      });
    }, 24);

    // Cleanup on component unmount
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    // Once progress reaches 100, call contentLoaded to update parent component/context
    // doing this to prevent error in console
    if (progress >= 100) {
      contentLoaded();
    }
  }, [progress, contentLoaded]);

  return (
    <div className="PreLander">
      <h2>περίμενε ένα λεπτό</h2>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        viewBox="0 0 400 400"
        id="Gears"
      >
        <path id="Artboard1" fill="none" d="M0 0H400V400H0z"></path>
        <g id="Artboard11">
          <g transform="translate(-30.476 -51.575)">
            <path
              id="GearB"
              fill="#fa8812"
              d="M162.478 88.412a102.593 102.593 0 00-19.856 0l-3.27 15.921a87.26 87.26 0 00-18.498 4.957l-10.793-12.153a102.622 102.622 0 00-17.196 9.928l5.128 15.423a87.271 87.271 0 00-13.541 13.542l-15.424-5.129a102.671 102.671 0 00-9.928 17.197l12.153 10.792a87.23 87.23 0 00-4.956 18.498l-15.922 3.27a102.763 102.763 0 000 19.857l15.922 3.27a87.213 87.213 0 004.956 18.498L59.1 233.076a102.702 102.702 0 009.928 17.196l15.424-5.128a87.221 87.221 0 0013.541 13.541l-5.128 15.424a102.622 102.622 0 0017.196 9.928l10.793-12.153a87.197 87.197 0 0018.498 4.956l3.27 15.921c6.603.642 13.253.642 19.856 0l3.271-15.921a87.23 87.23 0 0018.498-4.956l10.792 12.153a102.671 102.671 0 0017.197-9.928l-5.129-15.424a87.271 87.271 0 0013.542-13.541l15.423 5.128A102.702 102.702 0 00246 233.076l-12.153-10.793a87.275 87.275 0 004.957-18.498l15.921-3.27c.642-6.603.642-13.253 0-19.857l-15.921-3.27a87.291 87.291 0 00-4.957-18.498L246 148.098a102.671 102.671 0 00-9.928-17.197l-15.423 5.129a87.322 87.322 0 00-13.542-13.542l5.129-15.423a102.671 102.671 0 00-17.197-9.928l-10.792 12.153a87.291 87.291 0 00-18.498-4.957l-3.271-15.921zm-9.928 54.605c26.254 0 47.569 21.316 47.569 47.57s-21.315 47.569-47.569 47.569-47.569-21.315-47.569-47.569 21.315-47.57 47.569-47.57z"
            ></path>
          </g>
          <g transform="translate(125.376 70.402)">
            <path
              id="GearA"
              fill="#fa8812"
              d="M162.478 88.412a102.593 102.593 0 00-19.856 0l-3.27 15.921a87.26 87.26 0 00-18.498 4.957l-10.793-12.153a102.622 102.622 0 00-17.196 9.928l5.128 15.423a87.271 87.271 0 00-13.541 13.542l-15.424-5.129a102.671 102.671 0 00-9.928 17.197l12.153 10.792a87.23 87.23 0 00-4.956 18.498l-15.922 3.27a102.763 102.763 0 000 19.857l15.922 3.27a87.213 87.213 0 004.956 18.498L59.1 233.076a102.702 102.702 0 009.928 17.196l15.424-5.128a87.221 87.221 0 0013.541 13.541l-5.128 15.424a102.622 102.622 0 0017.196 9.928l10.793-12.153a87.197 87.197 0 0018.498 4.956l3.27 15.921c6.603.642 13.253.642 19.856 0l3.271-15.921a87.23 87.23 0 0018.498-4.956l10.792 12.153a102.671 102.671 0 0017.197-9.928l-5.129-15.424a87.271 87.271 0 0013.542-13.541l15.423 5.128A102.702 102.702 0 00246 233.076l-12.153-10.793a87.275 87.275 0 004.957-18.498l15.921-3.27c.642-6.603.642-13.253 0-19.857l-15.921-3.27a87.291 87.291 0 00-4.957-18.498L246 148.098a102.671 102.671 0 00-9.928-17.197l-15.423 5.129a87.322 87.322 0 00-13.542-13.542l5.129-15.423a102.671 102.671 0 00-17.197-9.928l-10.792 12.153a87.291 87.291 0 00-18.498-4.957l-3.271-15.921zm-9.928 54.605c26.254 0 47.569 21.316 47.569 47.57s-21.315 47.569-47.569 47.569-47.569-21.315-47.569-47.569 21.315-47.57 47.569-47.57z"
            ></path>
          </g>
        </g>
      </svg>
      <p>
        Επεξεργάζομαι το περιεχόμενο στα ελληνικά. <strong>{progress}%</strong>
      </p>
    </div>
  );
}

export default PreLander;
